// extracted by mini-css-extract-plugin
module.exports = {"card":"BlogSubscribeCard_card__n8ljy","image":"BlogSubscribeCard_image__al6_I","titleSection":"BlogSubscribeCard_titleSection__mbdDN"};